// src/data/mockData.js

import {
  generateCustomers,
    enhancePickups,
  enhanceDeliveries,
  generateCompletedJobs,
} from './mockDataGenerators';



export const mockCustomers = generateCustomers(30);



const _rawOrders = [
  {
    id: 101,
    number: "ORD-00101",
    customerId: 1,
    customerName: "Alice Johnson",
    serviceType: "Wash & Fold",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-05",
    pickupDate: "2026-06-05",
    deliveryDate: "2026-06-07",
    itemDetails: [{ name: "Dishdasha", quantity: 10, unitPrice: 1.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 1,
    timeline: [
      { status: "Waiting", date: "06/05/2026", time: "01:00 AM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 102,
    number: "ORD-00102",
    customerId: 2,
    customerName: "Bob Smith",
    serviceType: "Wash & Iron",
    status: "In Workshop",
    paymentStatus: "Paid",
    amount: 7.5,
    tax: 0.75,
    totalAmount: 8.25,
    date: "2026-06-05",
    pickupDate: "2026-06-05",
    deliveryDate: "2026-06-07",
    itemDetails: [{ name: "Shirt", quantity: 10, unitPrice: 0.75 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 2,
    timeline: [
      { status: "Waiting", date: "06/05/2026", time: "01:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/05/2026", time: "01:15 AM", updatedBy: "John Doe" }
    ]
  },
  {
    id: 103,
    number: "ORD-00103",
    customerId: 3,
    customerName: "Carol Davis",
    serviceType: "Dry Cleaning",
    status: "Ready",
    paymentStatus: "Partial",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-05",
    pickupDate: "2026-06-05",
    deliveryDate: "2026-06-07",
    itemDetails: [{ name: "Jacket", quantity: 10, unitPrice: 1.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 3,
    timeline: [
      { status: "Waiting", date: "06/05/2026", time: "01:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/05/2026", time: "01:15 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/05/2026", time: "03:00 AM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 104,
    number: "ORD-00104",
    customerId: 4,
    customerName: "Diana Wilson",
    serviceType: "Blanket Cleaning",
    status: "In Shop",
    paymentStatus: "Pending",
    amount: 50.0,
    tax: 5.0,
    totalAmount: 55.0,
    date: "2026-06-04",
    pickupDate: "2026-06-04",
    deliveryDate: "2026-06-06",
    itemDetails: [{ name: "Carpet", quantity: 10, unitPrice: 5.0 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 4,
    timeline: [
      { status: "Waiting", date: "06/04/2026", time: "09:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/04/2026", time: "09:30 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/04/2026", time: "11:00 AM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/04/2026", time: "11:15 AM", updatedBy: "Sarah Martinez" }
    ]
  },
  {
    id: 105,
    number: "ORD-00105",
    customerId: 5,
    customerName: "Eve Martinez",
    serviceType: "Premium Care",
    status: "H Services",
    paymentStatus: "Paid",
    amount: 150.0,
    tax: 15.0,
    totalAmount: 165.0,
    date: "2026-06-04",
    pickupDate: "2026-06-04",
    deliveryDate: "2026-06-11",
    itemDetails: [{ name: "Wedding Dress", quantity: 10, unitPrice: 15.0 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 5,
    timeline: [
      { status: "Waiting", date: "06/04/2026", time: "10:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/04/2026", time: "10:45 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/04/2026", time: "02:00 PM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/04/2026", time: "02:30 PM", updatedBy: "Sarah Martinez" },
      { status: "H Services", date: "06/04/2026", time: "03:00 PM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 106,
    number: "ORD-00106",
    customerId: 6,
    customerName: "Frank Turner",
    serviceType: "Ironing",
    status: "With Driver",
    paymentStatus: "Pending",
    amount: 7.5,
    tax: 0.75,
    totalAmount: 8.25,
    date: "2026-06-04",
    pickupDate: "2026-06-04",
    deliveryDate: "2026-06-05",
    itemDetails: [{ name: "Trousers", quantity: 10, unitPrice: 0.75 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 6,
    timeline: [
      { status: "Waiting", date: "06/04/2026", time: "08:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/04/2026", time: "08:30 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/04/2026", time: "10:00 AM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/04/2026", time: "10:30 AM", updatedBy: "Sarah Martinez" },
      { status: "H Services", date: "06/04/2026", time: "11:00 AM", updatedBy: "Dana Lee" },
      { status: "With Driver", date: "06/04/2026", time: "11:30 AM", updatedBy: "Frank Brown" }
    ]
  },
  {
    id: 107,
    number: "ORD-00107",
    customerId: 7,
    customerName: "Grace Lee",
    serviceType: "Wash & Fold",
    status: "Delivered",
    paymentStatus: "Paid",
    amount: 20.0,
    tax: 2.0,
    totalAmount: 22.0,
    date: "2026-06-03",
    pickupDate: "2026-06-03",
    deliveryDate: "2026-06-05",
    itemDetails: [{ name: "Abaya", quantity: 10, unitPrice: 2.0 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 7,
    timeline: [
      { status: "Waiting", date: "06/03/2026", time: "09:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/03/2026", time: "09:30 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/03/2026", time: "11:00 AM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/03/2026", time: "11:30 AM", updatedBy: "Sarah Martinez" },
      { status: "H Services", date: "06/03/2026", time: "12:00 PM", updatedBy: "Dana Lee" },
      { status: "With Driver", date: "06/03/2026", time: "01:30 PM", updatedBy: "Frank Brown" },
      { status: "Delivered", date: "06/03/2026", time: "03:00 PM", updatedBy: "Frank Brown" }
    ]
  },
  {
    id: 108,
    number: "ORD-00108",
    customerId: 1,
    customerName: "Alice Johnson",
    serviceType: "Dry Cleaning",
    status: "On Hold",
    paymentStatus: "Pending",
    amount: 20.0,
    tax: 2.0,
    totalAmount: 22.0,
    date: "2026-06-03",
    pickupDate: "2026-06-03",
    deliveryDate: "2026-06-05",
    itemDetails: [{ name: "Coat", quantity: 10, unitPrice: 2.0 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 8,
    timeline: [
      { status: "Waiting", date: "06/03/2026", time: "10:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/03/2026", time: "11:00 AM", updatedBy: "John Doe" },
      { status: "On Hold", date: "06/03/2026", time: "11:30 AM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 109,
    number: "ORD-00109",
    customerId: 2,
    customerName: "Bob Smith",
    serviceType: "Wash & Fold",
    status: "Return",
    paymentStatus: "Pending",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-02",
    pickupDate: "2026-06-02",
    deliveryDate: "2026-06-04",
    itemDetails: [{ name: "Sheet", quantity: 10, unitPrice: 1.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 1,
    timeline: [
      { status: "Waiting", date: "06/02/2026", time: "09:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/02/2026", time: "09:30 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/02/2026", time: "11:00 AM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/02/2026", time: "11:30 AM", updatedBy: "Sarah Martinez" },
      { status: "Return", date: "06/02/2026", time: "01:00 PM", updatedBy: "Sarah Martinez" }
    ]
  },
  {
    id: 110,
    number: "ORD-00110",
    customerId: 3,
    customerName: "Carol Davis",
    serviceType: "Dry Cleaning",
    status: "Cancel",
    paymentStatus: "Pending",
    amount: 25.0,
    tax: 2.5,
    totalAmount: 27.5,
    date: "2026-06-02",
    pickupDate: "2026-06-02",
    deliveryDate: "2026-06-04",
    itemDetails: [{ name: "Suit", quantity: 10, unitPrice: 2.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 2,
    timeline: [
      { status: "Waiting", date: "06/02/2026", time: "10:00 AM", updatedBy: "Dana Lee" },
      { status: "Cancel", date: "06/02/2026", time: "11:30 AM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 111,
    number: "ORD-00111",
    customerId: 4,
    customerName: "Diana Wilson",
    serviceType: "Wash & Iron",
    status: "In Store",
    paymentStatus: "Paid",
    amount: 5.0,
    tax: 0.5,
    totalAmount: 5.5,
    date: "2026-06-02",
    pickupDate: "2026-06-02",
    deliveryDate: "2026-06-04",
    itemDetails: [{ name: "Ghotraa", quantity: 10, unitPrice: 0.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 3,
    timeline: [
      { status: "Waiting", date: "06/02/2026", time: "02:00 PM", updatedBy: "Dana Lee" },
      { status: "In Store", date: "06/02/2026", time: "03:30 PM", updatedBy: "Sarah Martinez" }
    ]
  },
  // ── Express orders (one per branch) ──
  {
    id: 201,
    number: "ORD-00201",
    customerId: 1,
    customerName: "Alice Johnson",
    serviceType: "Urgent",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 22.5,
    tax: 2.25,
    totalAmount: 24.75,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Dishdasha", quantity: 3, unitPrice: 7.5 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Dana Lee",
    branchId: 1,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "08:00 AM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 202,
    number: "ORD-00202",
    customerId: 2,
    customerName: "Bob Smith",
    serviceType: "Urgent",
    status: "In Workshop",
    paymentStatus: "Paid",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Shirt", quantity: 5, unitPrice: 3.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Evan Wu",
    branchId: 2,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "08:15 AM", updatedBy: "Evan Wu" },
      { status: "In Workshop", date: "06/08/2026", time: "08:30 AM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 203,
    number: "ORD-00203",
    customerId: 3,
    customerName: "Carol Davis",
    serviceType: "Urgent",
    status: "Ready",
    paymentStatus: "Paid",
    amount: 18.0,
    tax: 1.8,
    totalAmount: 19.8,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Jacket", quantity: 2, unitPrice: 9.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Sarah Martinez",
    branchId: 3,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "07:30 AM", updatedBy: "Sarah Martinez" },
      { status: "In Workshop", date: "06/08/2026", time: "07:45 AM", updatedBy: "Sarah Martinez" },
      { status: "Ready", date: "06/08/2026", time: "09:00 AM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 204,
    number: "ORD-00204",
    customerId: 4,
    customerName: "Diana Wilson",
    serviceType: "Urgent",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 30.0,
    tax: 3.0,
    totalAmount: 33.0,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Carpet", quantity: 1, unitPrice: 30.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Kevin Park",
    branchId: 4,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "09:00 AM", updatedBy: "Kevin Park" }
    ]
  },
  {
    id: 205,
    number: "ORD-00205",
    customerId: 5,
    customerName: "Eve Martinez",
    serviceType: "Urgent",
    status: "In Workshop",
    paymentStatus: "Partial",
    amount: 12.0,
    tax: 1.2,
    totalAmount: 13.2,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Abaya", quantity: 2, unitPrice: 6.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Lisa Thompson",
    branchId: 5,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "08:45 AM", updatedBy: "Lisa Thompson" },
      { status: "In Workshop", date: "06/08/2026", time: "09:00 AM", updatedBy: "Lisa Thompson" }
    ]
  },
  {
    id: 206,
    number: "ORD-00206",
    customerId: 6,
    customerName: "Frank Turner",
    serviceType: "Urgent",
    status: "Ready",
    paymentStatus: "Paid",
    amount: 10.0,
    tax: 1.0,
    totalAmount: 11.0,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Trousers", quantity: 4, unitPrice: 2.5 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Jennifer Lee",
    branchId: 6,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "07:00 AM", updatedBy: "Jennifer Lee" },
      { status: "In Workshop", date: "06/08/2026", time: "07:15 AM", updatedBy: "Jennifer Lee" },
      { status: "Ready", date: "06/08/2026", time: "08:30 AM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 207,
    number: "ORD-00207",
    customerId: 7,
    customerName: "Grace Lee",
    serviceType: "Urgent",
    status: "With Driver",
    paymentStatus: "Paid",
    amount: 20.0,
    tax: 2.0,
    totalAmount: 22.0,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Dress", quantity: 4, unitPrice: 5.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Michael Torres",
    branchId: 7,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "07:30 AM", updatedBy: "Michael Torres" },
      { status: "In Workshop", date: "06/08/2026", time: "07:45 AM", updatedBy: "Michael Torres" },
      { status: "Ready", date: "06/08/2026", time: "09:00 AM", updatedBy: "Evan Wu" },
      { status: "With Driver", date: "06/08/2026", time: "09:30 AM", updatedBy: "Frank Brown" }
    ]
  },
  {
    id: 208,
    number: "ORD-00208",
    customerId: 1,
    customerName: "Alice Johnson",
    serviceType: "Urgent",
    status: "Delivered",
    paymentStatus: "Paid",
    amount: 9.0,
    tax: 0.9,
    totalAmount: 9.9,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Shmage", quantity: 4, unitPrice: 2.25 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Dana Lee",
    branchId: 8,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "06:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/08/2026", time: "06:15 AM", updatedBy: "Dana Lee" },
      { status: "Ready", date: "06/08/2026", time: "07:00 AM", updatedBy: "Evan Wu" },
      { status: "With Driver", date: "06/08/2026", time: "07:30 AM", updatedBy: "Frank Brown" },
      { status: "Delivered", date: "06/08/2026", time: "08:30 AM", updatedBy: "Frank Brown" }
    ]
  },
  // ── Additional normal orders for branches 4-8 (ensure every branch has at least 2 orders) ──
  {
    id: 212,
    number: "ORD-00212",
    customerId: 5,
    customerName: "Eve Martinez",
    serviceType: "Wash & Fold",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 12.0,
    tax: 1.2,
    totalAmount: 13.2,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-09",
    itemDetails: [{ name: "Hegab", quantity: 8, unitPrice: 1.5 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Lisa Thompson",
    branchId: 4,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "10:00 AM", updatedBy: "Lisa Thompson" }
    ]
  },
  {
    id: 213,
    number: "ORD-00213",
    customerId: 6,
    customerName: "Frank Turner",
    serviceType: "Wash & Iron",
    status: "In Workshop",
    paymentStatus: "Paid",
    amount: 7.5,
    tax: 0.75,
    totalAmount: 8.25,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-09",
    itemDetails: [{ name: "Shirt", quantity: 10, unitPrice: 0.75 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Kevin Park",
    branchId: 5,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "11:00 AM", updatedBy: "Kevin Park" },
      { status: "In Workshop", date: "06/07/2026", time: "11:30 AM", updatedBy: "Kevin Park" }
    ]
  },
  {
    id: 214,
    number: "ORD-00214",
    customerId: 7,
    customerName: "Grace Lee",
    serviceType: "Dry Cleaning",
    status: "Ready",
    paymentStatus: "Paid",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-09",
    itemDetails: [{ name: "Coat", quantity: 3, unitPrice: 5.0 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Jennifer Lee",
    branchId: 6,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "09:00 AM", updatedBy: "Jennifer Lee" },
      { status: "In Workshop", date: "06/07/2026", time: "09:30 AM", updatedBy: "Jennifer Lee" },
      { status: "Ready", date: "06/07/2026", time: "12:00 PM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 215,
    number: "ORD-00215",
    customerId: 2,
    customerName: "Bob Smith",
    serviceType: "Wash & Fold",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 10.0,
    tax: 1.0,
    totalAmount: 11.0,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-09",
    itemDetails: [{ name: "Bisht", quantity: 2, unitPrice: 5.0 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Michael Torres",
    branchId: 7,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "01:00 PM", updatedBy: "Michael Torres" }
    ]
  },
  {
    id: 216,
    number: "ORD-00216",
    customerId: 3,
    customerName: "Carol Davis",
    serviceType: "Premium Care",
    status: "In Workshop",
    paymentStatus: "Partial",
    amount: 25.0,
    tax: 2.5,
    totalAmount: 27.5,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-10",
    itemDetails: [{ name: "Evening Dress", quantity: 2, unitPrice: 12.5 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Dana Lee",
    branchId: 8,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "02:00 PM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/07/2026", time: "02:30 PM", updatedBy: "Dana Lee" }
    ]
  }
];

export const formatDateOffset = (daysAgo = 0) => {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().split('T')[0];
};

export const formatTimelineDate = (daysAgo = 0) => {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

export const mockOrders = _rawOrders.map((o, idx) => {
  const daysAgo = idx < 5 ? 0 : idx < 10 ? 1 : Math.min(28, (idx - 8) * 2);
  return {
    ...o,
    date: formatDateOffset(daysAgo),
    pickupDate: formatDateOffset(daysAgo),
    deliveryDate: formatDateOffset(Math.max(0, daysAgo - 2)),
    timeline: (o.timeline || []).map((tl) => ({
      ...tl,
      date: formatTimelineDate(daysAgo)
    }))
  };
});

export const mockPayments = mockOrders.map((o, idx) => {
  const methods = ['Cash', 'Card', 'Link', 'Wamd'];
  const method = methods[idx % methods.length];
  const amt = Number(o.totalAmount || o.amount || 15);
  return {
    id: idx + 1,
    paymentId: `PAY-${String(100 + idx + 1).padStart(5, '0')}`,
    orderNumber: o.number,
    orderId: o.id,
    customerId: o.customerId,
    customerName: o.customerName,
    amount: amt,
    method,
    status: o.paymentStatus || (idx % 7 === 0 ? 'Pending' : idx % 9 === 0 ? 'Partial' : 'Paid'),
    date: o.date,
    createdAt: `${o.date}T10:30:00.000Z`,
    branchId: o.branchId || (idx % 8) + 1,
    branch: o.branch || 'Ragheey'
  };
});

export const mockServices = [
  { id: 1, name: "Wash & Fold", category: "Washing", price: 2.5, estimatedTime: "24 hours", status: "Active", description: "Standard wash and fold service" },
  { id: 2, name: "Dry Cleaning", category: "Dry Cleaning", price: 5.0, estimatedTime: "48 hours", status: "Active", description: "Professional dry cleaning" },
  { id: 3, name: "Ironing", category: "Ironing", price: 1.5, estimatedTime: "12 hours", status: "Active", description: "Professional ironing service" },
  { id: 4, name: "Wash & Iron", category: "Wash & Iron", price: 4.0, estimatedTime: "36 hours", status: "Active", description: "Wash and iron combined" },
  { id: 5, name: "Premium Care", category: "Premium Care", price: 8.0, estimatedTime: "72 hours", status: "Active", description: "Delicate fabric care" },
  { id: 6, name: "Stain Removal", category: "Premium Care", price: 3.5, estimatedTime: "48 hours", status: "Active", description: "Special stain treatment" },
  { id: 7, name: "Express Wash", category: "Washing", price: 4.5, estimatedTime: "6 hours", status: "Active", description: "Fast turnaround wash" },
  { id: 8, name: "Blanket Cleaning", category: "Washing", price: 6.0, estimatedTime: "48 hours", status: "Active", description: "Large item cleaning" },
  { id: 9, name: "Wool Care", category: "Premium Care", price: 7.0, estimatedTime: "72 hours", status: "Inactive", description: "Specialized wool cleaning" },
  { id: 10, name: "Silk Handling", category: "Premium Care", price: 9.0, estimatedTime: "72 hours", status: "Active", description: "Delicate silk treatment" },
  { id: 11, name: "Wedding Dress", category: "Premium Care", price: 25.0, estimatedTime: "7 days", status: "Active", description: "Special occasion dress care" },
  { id: 12, name: "Leather Cleaning", category: "Premium Care", price: 12.0, estimatedTime: "72 hours", status: "Active", description: "Leather item care" },
  { id: 13, name: "Uniform Cleaning", category: "Dry Cleaning", price: 3.0, estimatedTime: "24 hours", status: "Active", description: "Professional uniform cleaning" },
  { id: 14, name: "Suit Pressing", category: "Ironing", price: 2.5, estimatedTime: "12 hours", status: "Active", description: "Suit dry cleaning and pressing" },
  { id: 15, name: "Bulk Wash", category: "Washing", price: 1.5, estimatedTime: "24 hours", status: "Active", description: "Discounted bulk service" },
];

export const mockStaff = [
  // Admins — each assigned to a specific branch (branchId matches branches list)
  { id: 1, name: "Dana Lee", email: "dana@tuhama.com", phone: "555-0001", address: "100 Executive Blvd", username: "danalee", role: "Admin", branch: "Ragheey", branchId: 1, status: "Active", joiningDate: "2024-01-15", ordersHandled: 0, deliveriesCompleted: 0, paymentsCollected: 0, recentActivity: "Approved new services" },
  { id: 2, name: "Marcus Johnson", email: "marcus@tuhama.com", phone: "555-0002", address: "105 Corporate Ave", username: "marcusj", role: "Admin", branch: "Mishrif", branchId: 2, status: "Active", joiningDate: "2024-02-01", ordersHandled: 0, deliveriesCompleted: 0, paymentsCollected: 0, recentActivity: "Created new pickup route" },
  { id: 3, name: "Patricia Wong", email: "patricia@tuhama.com", phone: "555-0003", address: "110 Business Ln", username: "patriciaw", role: "Admin", branch: "Andalus", branchId: 3, status: "Active", joiningDate: "2024-03-10", ordersHandled: 0, deliveriesCompleted: 0, paymentsCollected: 0, recentActivity: "Updated pricing" },

  // Counter Staff
  { id: 4, name: "Evan Wu", email: "evan@tuhama.com", phone: "555-0004", address: "200 Main St", username: "evanwu", role: "Counter Staff", status: "Active", joiningDate: "2024-04-05", ordersHandled: 156, deliveriesCompleted: 0, paymentsCollected: 2340, recentActivity: "Processed order ORD-00102" },
  { id: 5, name: "Sarah Martinez", email: "sarah@tuhama.com", phone: "555-0005", address: "205 Park Ave", username: "sarahm", role: "Counter Staff", status: "Active", joiningDate: "2024-04-10", ordersHandled: 142, deliveriesCompleted: 0, paymentsCollected: 2156, recentActivity: "Updated customer profile" },
  { id: 6, name: "Kevin Park", email: "kevin@tuhama.com", phone: "555-0006", address: "210 Oak Street", username: "kevinp", role: "Counter Staff", status: "Active", joiningDate: "2024-05-01", ordersHandled: 128, deliveriesCompleted: 0, paymentsCollected: 1945, recentActivity: "Verified payment" },
  { id: 7, name: "Lisa Thompson", email: "lisa@tuhama.com", phone: "555-0007", address: "215 Elm Rd", username: "lisat", role: "Counter Staff", status: "Active", joiningDate: "2024-05-15", ordersHandled: 134, deliveriesCompleted: 0, paymentsCollected: 2034, recentActivity: "Added new customer" },
  { id: 8, name: "David Chen", email: "david@tuhama.com", phone: "555-0008", address: "220 Pine Ave", username: "davidc", role: "Counter Staff", status: "Inactive", joiningDate: "2024-06-01", ordersHandled: 89, deliveriesCompleted: 0, paymentsCollected: 1345, recentActivity: "On leave" },
  { id: 9, name: "Jennifer Lee", email: "jennifer@tuhama.com", phone: "555-0009", address: "225 Maple Dr", username: "jenniferl", role: "Counter Staff", status: "Active", joiningDate: "2024-06-05", ordersHandled: 167, deliveriesCompleted: 0, paymentsCollected: 2523, recentActivity: "Handled customer complaint" },
  { id: 10, name: "Michael Torres", email: "michael@tuhama.com", phone: "555-0010", address: "230 Cedar Ln", username: "michaelt", role: "Counter Staff", status: "Active", joiningDate: "2024-06-10", ordersHandled: 145, deliveriesCompleted: 0, paymentsCollected: 2189, recentActivity: "Processed refund" },
  { id: 11, name: "Amanda Rodriguez", email: "amanda@tuhama.com", phone: "555-0011", address: "235 Birch St", username: "amandar", role: "Counter Staff", status: "Suspended", joiningDate: "2024-06-15", ordersHandled: 0, deliveriesCompleted: 0, paymentsCollected: 0, recentActivity: "Account suspended" },

  // Delivery Staff
  { id: 12, name: "Frank Brown", email: "frank@tuhama.com", phone: "555-0012", address: "300 Industrial Ave", username: "frankb", role: "Delivery Staff", status: "Active", joiningDate: "2024-04-20", ordersHandled: 45, deliveriesCompleted: 89, paymentsCollected: 0, recentActivity: "Completed DEL-004" },
  { id: 13, name: "Henry Miller", email: "henry@tuhama.com", phone: "555-0013", address: "305 Commerce Blvd", username: "henrym", role: "Delivery Staff", status: "Active", joiningDate: "2024-05-05", ordersHandled: 38, deliveriesCompleted: 76, paymentsCollected: 0, recentActivity: "Assigned to PKP-010" },
  { id: 14, name: "Robert Garcia", email: "robert@tuhama.com", phone: "555-0014", address: "310 Factory Rd", username: "robertg", role: "Delivery Staff", status: "Active", joiningDate: "2024-05-20", ordersHandled: 52, deliveriesCompleted: 94, paymentsCollected: 0, recentActivity: "Started delivery route" },
  { id: 15, name: "Carlos Mendez", email: "carlos@tuhama.com", phone: "555-0015", address: "315 Warehouse St", username: "carlasm", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-01", ordersHandled: 41, deliveriesCompleted: 67, paymentsCollected: 0, recentActivity: "Updated pickup status" },
  { id: 16, name: "James Wilson", email: "james@tuhama.com", phone: "555-0016", address: "320 Distribution Ln", username: "jamesw", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-05", ordersHandled: 35, deliveriesCompleted: 58, paymentsCollected: 0, recentActivity: "Completed delivery route" },
  { id: 17, name: "Antonio Lopez", email: "antonio@tuhama.com", phone: "555-0017", address: "325 Logistics Ave", username: "antoniol", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-10", ordersHandled: 48, deliveriesCompleted: 82, paymentsCollected: 0, recentActivity: "Assigned to PKP-016" },
  { id: 18, name: "Diego Sanchez", email: "diego@tuhama.com", phone: "555-0018", address: "330 Transport Dr", username: "diegos", role: "Delivery Staff", status: "Inactive", joiningDate: "2024-06-12", ordersHandled: 12, deliveriesCompleted: 18, paymentsCollected: 0, recentActivity: "Medical leave" },
  { id: 19, name: "Miguel Flores", email: "miguel@tuhama.com", phone: "555-0019", address: "335 Route St", username: "miguelf", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-15", ordersHandled: 33, deliveriesCompleted: 54, paymentsCollected: 0, recentActivity: "In transit with order" },
  { id: 20, name: "Victor Ramirez", email: "victor@tuhama.com", phone: "555-0020", address: "340 Shipping Ln", username: "victorm", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-18", ordersHandled: 29, deliveriesCompleted: 42, paymentsCollected: 0, recentActivity: "Ready for assignment" },
  { id: 21, name: "Eduardo Gutierrez", email: "eduardo@tuhama.com", phone: "555-0021", address: "345 Cargo Ave", username: "eduardog", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-20", ordersHandled: 44, deliveriesCompleted: 71, paymentsCollected: 0, recentActivity: "Completed DEL-020" },
];

export const mockRoles = [
  {
    id: 1,
    name: "Admin",
    description: "Full system access and administrative privileges",
    permissions: [
      "view_dashboard",
      "manage_customers",
      "manage_orders",
      "manage_services",
      "manage_pricing",
      "manage_pickups",
      "manage_deliveries",
      "manage_payments",
      "manage_staff",
      "manage_roles",
      "view_reports",
      "manage_notifications",
      "manage_settings",
      "view_analytics",
      "export_data",
      "manage_permissions",
    ],
  },
  {
    id: 2,
    name: "Counter Staff",
    description: "Counter and customer service operations",
    permissions: [
      "view_dashboard",
      "manage_customers",
      "create_orders",
      "view_orders",
      "manage_payments",
      "track_orders",
      "view_pickups",
      "view_deliveries",
    ],
  },
  {
    id: 3,
    name: "Delivery Staff",
    description: "Pickup and delivery operations",
    permissions: [
      "view_dashboard",
      "view_assigned_pickups",
      "update_pickup_status",
      "view_assigned_deliveries",
      "update_delivery_status",
      "view_completed_jobs",
      "view_route_map",
    ],
  },
];

export const permissionsReference = {
  view_dashboard: "View Dashboard",
  manage_customers: "Manage Customers",
  manage_orders: "Manage Orders",
  manage_services: "Manage Laundry Services",
  manage_pricing: "Manage Pricing",
  manage_pickups: "Manage Pickups",
  manage_deliveries: "Manage Deliveries",
  manage_payments: "Manage Payments",
  manage_staff: "Manage Staff",
  manage_roles: "Manage Roles",
  view_reports: "View Reports",
  manage_notifications: "Manage Notifications",
  manage_settings: "Manage Settings",
  view_analytics: "View Analytics",
  export_data: "Export Data",
  manage_permissions: "Manage Permissions",
  create_orders: "Create Orders",
  view_orders: "View Orders",
  track_orders: "Track Orders",
  view_pickups: "View Pickups",
  view_deliveries: "View Deliveries",
  view_assigned_pickups: "View Assigned Pickups",
  update_pickup_status: "Update Pickup Status",
  view_assigned_deliveries: "View Assigned Deliveries",
  update_delivery_status: "Update Delivery Status",
  view_completed_jobs: "View Completed Jobs",
  view_route_map: "View Route Map",
};

const _rawPickups = [
  { id: 1, requestId: "PKP-001", customer: "Alice Johnson", address: "123 Main St", pickupDate: formatDateOffset(0), assignedStaff: "Robert Garcia", status: "Assigned", notes: "Call before pickup" },
  { id: 2, requestId: "PKP-002", customer: "Bob Smith", address: "456 Oak Ave", pickupDate: formatDateOffset(0), assignedStaff: "Robert Garcia", status: "Scheduled", notes: "Morning pickup preferred" },
  { id: 3, requestId: "PKP-003", customer: "Carol Davis", address: "789 Pine Rd", pickupDate: formatDateOffset(0), assignedStaff: "Frank Brown", status: "Assigned", notes: "Gate code 1234" },
  { id: 4, requestId: "PKP-004", customer: "Diana Wilson", address: "321 Elm St", pickupDate: formatDateOffset(0), assignedStaff: "Frank Brown", status: "Picked Up", notes: "Urgent pickup" },
  { id: 5, requestId: "PKP-005", customer: "Eve Martinez", address: "654 Maple Ave", pickupDate: formatDateOffset(1), assignedStaff: "Robert Garcia", status: "Completed", notes: "Leave at porch" },
  { id: 6, requestId: "PKP-006", customer: "Alice Johnson", address: "123 Main St", pickupDate: formatDateOffset(1), assignedStaff: "Henry Miller", status: "Completed", notes: "" },
  { id: 7, requestId: "PKP-007", customer: "Bob Smith", address: "456 Oak Ave", pickupDate: formatDateOffset(2), assignedStaff: "Robert Garcia", status: "Completed", notes: "Business hours only" },
  { id: 8, requestId: "PKP-008", customer: "Carol Davis", address: "789 Pine Rd", pickupDate: formatDateOffset(2), assignedStaff: "Frank Brown", status: "Completed", notes: "" },
  { id: 9, requestId: "PKP-009", customer: "Diana Wilson", address: "321 Elm St", pickupDate: formatDateOffset(3), assignedStaff: "Henry Miller", status: "Completed", notes: "" },
  { id: 10, requestId: "PKP-010", customer: "Eve Martinez", address: "654 Maple Ave", pickupDate: formatDateOffset(3), assignedStaff: "Robert Garcia", status: "Completed", notes: "" },
  { id: 11, requestId: "PKP-011", customer: "Alice Johnson", address: "123 Main St", pickupDate: formatDateOffset(4), assignedStaff: "Frank Brown", status: "Completed", notes: "" },
  { id: 12, requestId: "PKP-012", customer: "Bob Smith", address: "456 Oak Ave", pickupDate: formatDateOffset(5), assignedStaff: "Robert Garcia", status: "Completed", notes: "" },
  { id: 13, requestId: "PKP-013", customer: "Carol Davis", address: "789 Pine Rd", pickupDate: formatDateOffset(5), assignedStaff: "Henry Miller", status: "Completed", notes: "" },
  { id: 14, requestId: "PKP-014", customer: "Diana Wilson", address: "321 Elm St", pickupDate: formatDateOffset(6), assignedStaff: "Frank Brown", status: "Completed", notes: "" },
  { id: 15, requestId: "PKP-015", customer: "Eve Martinez", address: "654 Maple Ave", pickupDate: formatDateOffset(7), assignedStaff: "Robert Garcia", status: "Completed", notes: "" },
];

export const mockPickups = enhancePickups(_rawPickups, mockCustomers);

const _rawDeliveries = [
  { id: 1, deliveryId: "DEL-001", customer: "Alice Johnson", deliveryDate: formatDateOffset(0), assignedStaff: "Robert Garcia", orderCount: 2, status: "Out for Delivery", address: "123 Main St" },
  { id: 2, deliveryId: "DEL-002", customer: "Bob Smith", deliveryDate: formatDateOffset(0), assignedStaff: "Robert Garcia", orderCount: 1, status: "Scheduled", address: "456 Oak Ave" },
  { id: 3, deliveryId: "DEL-003", customer: "Carol Davis", deliveryDate: formatDateOffset(0), assignedStaff: "Robert Garcia", orderCount: 1, status: "Delivered", address: "789 Pine Rd" },
  { id: 4, deliveryId: "DEL-004", customer: "Diana Wilson", deliveryDate: formatDateOffset(0), assignedStaff: "Frank Brown", orderCount: 3, status: "Delivered", address: "321 Elm St" },
  { id: 5, deliveryId: "DEL-005", customer: "Eve Martinez", deliveryDate: formatDateOffset(0), assignedStaff: "Frank Brown", orderCount: 1, status: "Out for Delivery", address: "654 Maple Ave" },
  { id: 6, deliveryId: "DEL-006", customer: "Alice Johnson", deliveryDate: formatDateOffset(1), assignedStaff: "Robert Garcia", orderCount: 2, status: "Delivered", address: "123 Main St" },
  { id: 7, deliveryId: "DEL-007", customer: "Bob Smith", deliveryDate: formatDateOffset(1), assignedStaff: "Henry Miller", orderCount: 1, status: "Delivered", address: "456 Oak Ave" },
  { id: 8, deliveryId: "DEL-008", customer: "Carol Davis", deliveryDate: formatDateOffset(2), assignedStaff: "Frank Brown", orderCount: 2, status: "Delivered", address: "789 Pine Rd" },
  { id: 9, deliveryId: "DEL-009", customer: "Diana Wilson", deliveryDate: formatDateOffset(2), assignedStaff: "Robert Garcia", orderCount: 1, status: "Delivered", address: "321 Elm St" },
  { id: 10, deliveryId: "DEL-010", customer: "Eve Martinez", deliveryDate: formatDateOffset(3), assignedStaff: "Henry Miller", orderCount: 2, status: "Delivered", address: "654 Maple Ave" },
  { id: 11, deliveryId: "DEL-011", customer: "Alice Johnson", deliveryDate: formatDateOffset(4), assignedStaff: "Frank Brown", orderCount: 1, status: "Delivered", address: "123 Main St" },
  { id: 12, deliveryId: "DEL-012", customer: "Bob Smith", deliveryDate: formatDateOffset(5), assignedStaff: "Robert Garcia", orderCount: 2, status: "Delivered", address: "456 Oak Ave" },
];

export const mockDeliveries = enhanceDeliveries(_rawDeliveries, mockCustomers, mockOrders);

export const mockCompletedJobs = generateCompletedJobs(mockPickups, mockDeliveries);

export const mockBranches = [
  { id: 1, name: 'Ragheey', address: 'Block 2, Street 15, Ragheey', phone: '+965 2200 1101', email: 'ragheey@tuhama.com', status: 'Active', manager: 'Patricia Wong' },
  { id: 2, name: 'Mishrif', address: 'Block 4, Avenue 2, Mishrif', phone: '+965 2200 1102', email: 'mishrif@tuhama.com', status: 'Active', manager: 'Marcus Johnson' },
  { id: 3, name: 'Andalus', address: 'Block 1, Street 8, Andalus', phone: '+965 2200 1103', email: 'andalus@tuhama.com', status: 'Active', manager: 'Patricia Wong' },
  { id: 4, name: 'Ardiya', address: 'Block 3, Street 20, Ardiya', phone: '+965 2200 1104', email: 'ardiya@tuhama.com', status: 'Active', manager: 'Dana Lee' },
  { id: 5, name: 'Khaitan', address: 'Block 6, Street 4, Khaitan', phone: '+965 2200 1105', email: 'khaitan@tuhama.com', status: 'Active', manager: 'John Doe' },
  { id: 6, name: 'Qurain', address: 'Block 2, Avenue 5, Qurain', phone: '+965 2200 1106', email: 'qurain@tuhama.com', status: 'Active', manager: 'Evan Wu' },
  { id: 7, name: 'Jahra', address: 'Block 5, Street 12, Jahra', phone: '+965 2200 1107', email: 'jahra@tuhama.com', status: 'Active', manager: 'Frank Brown' },
  { id: 8, name: 'Rigai', address: 'Block 1, Street 3, Rigai', phone: '+965 2200 1108', email: 'rigai@tuhama.com', status: 'Active', manager: 'Henry Miller' },
  { id: 9, name: 'Home Service', address: 'Central Logistics & Home Delivery Hub', phone: '+965 2222 0000', email: 'homeservice@tuhama.com', status: 'Active', manager: 'Robert Garcia', isSystemBranch: true }
];

export const mockDrivers = [
  { id: 1, driverNo: "DRV-001", name: "Frank Brown", driverName: "Frank Brown", mobile: "555-0101", tel: "2200-1111", area: "Salmiya", branch: "Mishrif", status: "Available", carNo: "KUW-4821", civilId: "290123456781", nationality: "Kuwaiti" },
  { id: 2, driverNo: "DRV-002", name: "Henry Miller", driverName: "Henry Miller", mobile: "555-0102", tel: "2200-1112", area: "Hawally", branch: "Andalus", status: "On Delivery", carNo: "KUW-9312", civilId: "288123456782", nationality: "Egyptian" },
  { id: 3, driverNo: "DRV-003", name: "Robert Garcia", driverName: "Robert Garcia", mobile: "555-0103", tel: "2200-1113", area: "Kuwait City", branch: "Ragheey", status: "Assigned", carNo: "KUW-5541", civilId: "292123456783", nationality: "Indian" },
  { id: 4, driverNo: "DRV-004", name: "Diego Sanchez", driverName: "Diego Sanchez", mobile: "555-0104", tel: "2200-1114", area: "Ardiya", branch: "Ardiya", status: "Available", carNo: "KUW-7723", civilId: "285123456784", nationality: "Filipino" },
  { id: 5, driverNo: "DRV-005", name: "Miguel Flores", driverName: "Miguel Flores", mobile: "555-0105", tel: "2200-1115", area: "Khaitan", branch: "Khaitan", status: "On Delivery", carNo: "KUW-3319", civilId: "291123456785", nationality: "Kuwaiti" },
  { id: 6, driverNo: "DRV-006", name: "Victor Ramirez", driverName: "Victor Ramirez", mobile: "555-0106", tel: "2200-1116", area: "Qurain", branch: "Qurain", status: "Off Duty", carNo: "KUW-8840", civilId: "287123456786", nationality: "Lebanese" },
  { id: 7, driverNo: "DRV-007", name: "Eduardo Gutierrez", driverName: "Eduardo Gutierrez", mobile: "555-0107", tel: "2200-1117", area: "Jahra", branch: "Jahra", status: "Available", carNo: "KUW-1290", civilId: "293123456787", nationality: "Syrian" }
];

export const mockExpenses = [
  { id: 1, expenseId: "EXP-001", title: "Detergent & Softener Restock", category: "Laundry Supplies & Detergents", amount: 45.0, date: formatDateOffset(0), shift: "Morning", notes: "Purchased bulk Ariel & Comfort", branchId: 1, createdBy: "Patricia Wong" },
  { id: 2, expenseId: "EXP-002", title: "Delivery Van Fuel Refill", category: "Fuel & Petrol", amount: 12.5, date: formatDateOffset(0), shift: "Morning", notes: "Van #KUW-4821 full tank", branchId: 1, createdBy: "Frank Brown" },
  { id: 3, expenseId: "EXP-003", title: "Plastic Garment Covers & Hangers", category: "Packaging & Bags", amount: 28.0, date: formatDateOffset(1), shift: "Evening", notes: "500 standard covers", branchId: 2, createdBy: "Kevin Park" },
  { id: 4, expenseId: "EXP-004", title: "Iron Steamer Heating Coil Repair", category: "Shop Maintenance & Repairs", amount: 35.0, date: formatDateOffset(2), shift: "Morning", notes: "Technician service fee", branchId: 3, createdBy: "John Doe" },
  { id: 5, expenseId: "EXP-005", title: "Staff Refreshments & Tea", category: "Tea & Refreshments", amount: 6.5, date: formatDateOffset(2), shift: "Evening", notes: "Weekly coffee & tea supplies", branchId: 1, createdBy: "Dana Lee" },
  { id: 6, expenseId: "EXP-006", title: "Shop Electricity & Water Bill", category: "Utilities & Bills", amount: 85.0, date: formatDateOffset(4), shift: "Morning", notes: "Monthly utility clearance", branchId: 2, createdBy: "Patricia Wong" },
  { id: 7, expenseId: "EXP-007", title: "Petty Cash Driver Tolls", category: "Staff Petty Cash", amount: 10.0, date: formatDateOffset(5), shift: "Evening", notes: "Delivery dispatch emergency cash", branchId: 4, createdBy: "Robert Garcia" }
];

export const mockNotifications = [
  { id: 1, title: "New Order Created", message: "Order #ORD-00101 created by Counter Staff", type: "order", createdAt: new Date(Date.now() - 1000 * 60 * 15).toISOString(), read: false, branchId: 1 },
  { id: 2, title: "Order Ready for Pickup", message: "Order #ORD-00103 is ready for pickup/delivery", type: "order", createdAt: new Date(Date.now() - 1000 * 60 * 45).toISOString(), read: false, branchId: 2 },
  { id: 3, title: "Delivery Completed", message: "Delivery #DEL-004 completed by Frank Brown", type: "delivery", createdAt: new Date(Date.now() - 1000 * 60 * 120).toISOString(), read: true, branchId: 1 },
  { id: 4, title: "Payment Received", message: "Payment of 16.500 KWD received via K-Net", type: "payment", createdAt: new Date(Date.now() - 1000 * 60 * 180).toISOString(), read: true, branchId: 3 },
  { id: 5, title: "System Login", message: "Admin Patricia Wong logged in to Andalus branch", type: "security", createdAt: new Date(Date.now() - 1000 * 60 * 240).toISOString(), read: true, branchId: 3 }
];

export const mockAreas = ['Salmiya', 'Hawally', 'Kuwait City', 'Mishrif', 'Andalus', 'Ardiya', 'Khaitan', 'Qurain', 'Jahra', 'Rigai'];

